// src/plugins/vee-validate.js
import { extend, configure } from 'vee-validate'
import {
  required,
  min,
  max,
  numeric,
  min_value,
  email
} from 'vee-validate/dist/rules'

// Cấu hình mặc định để {_field_} hoạt động
configure({
  defaultMessage: '{_field_} không hợp lệ'
})

// Rule có sẵn + dùng {_field_}
extend('required', { ...required, message: '{_field_} là bắt buộc' })
extend('min', { ...min, message: '{_field_} phải có ít nhất {length} ký tự' })
extend('max', { ...max, message: '{_field_} không được quá {length} ký tự' })
extend('numeric', { ...numeric, message: '{_field_} chỉ được nhập số' })
extend('min_value', { ...min_value, message: '{_field_} phải ≥ {min}' })

// Custom rules – tất cả dùng {_field_}
extend('hasId', {
  validate: value => !!value?.id,
  message: '{_field_} là bắt buộc'
})

extend('hasFile', {
  validate: value => !!value?.fileId || !!value?.path,
  message: 'Vui lòng tải {_field_} lên'
})

extend('futureOrToday', {
  validate: value => {
    if (!value) return true
    const today = new Date()
    today.setHours(0, 0, 0, 0)
    const selected = new Date(value)
    selected.setHours(0, 0, 0, 0)
    return selected >= today
  },
  message: '{_field_} không được nhỏ hơn hôm nay'
})

extend('ckeditorNotEmpty', {
  validate: value => {
    if (!value) return false
    const text = value.replace(/<[^>]*>/g, '').trim()
    return text.length > 0
  },
  message: '{_field_} không được để trống'
})